<!--<h1>{{IsShowDetail}}</h1>-->
<div *ngIf='!IsShowDetail'>
  <div class="modal-header">
    <h4 class="modal-title">Legal Info</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <!-- Form actions layout section start -->
    <section id="form-action-layouts">


      <div class="row justify-content-md-center">
        <div class="col-md-12">
          <div class="card">

            <div class="card-body">
              <div class="px-3">
                <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">


                  <div class="form-body">


                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">Charge</label>
                        <input type="text" class="form-control" id="CurrentActorLegalInfoRequest.Charge" [(ngModel)]="CurrentActorLegalInfoRequest.Charge" name="CurrentActorLegalInfoRequest.Charge" placeholder="Charge" required>
                      </div>
                    </div>


                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput4">Charge Date</label>
                        <input type="date" class="form-control" id="CurrentActorLegalInfoRequest.ChargeDate" [(ngModel)]="CurrentActorLegalInfoRequest.ChargeDate" name="CurrentActorLegalInfoRequest.ChargeDate" placeholder="ChargeDate" required>
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">Reason</label>
                        <input type="text" class="form-control" id="CurrentActorLegalInfoRequest.Reason" [(ngModel)]="CurrentActorLegalInfoRequest.Reason" name="CurrentActorLegalInfoRequest.Reason" placeholder="Reason" required>
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">Court</label>
                        <input type="text" class="form-control" id="CurrentActorLegalInfoRequest.Court" [(ngModel)]="CurrentActorLegalInfoRequest.Court" name="CurrentActorLegalInfoRequest.Court" placeholder="Court">
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">Disposition</label>
                        <input type="text" class="form-control" id="CurrentActorLegalInfoRequest.Disposition" [(ngModel)]="CurrentActorLegalInfoRequest.Disposition" name="CurrentActorLegalInfoRequest.Disposition" placeholder="Disposition">
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">State</label>
                        <input type="text" class="form-control" id="CurrentActorLegalInfoRequest.State" [(ngModel)]="CurrentActorLegalInfoRequest.State" name="CurrentActorLegalInfoRequest.State" placeholder="State">
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">Remarks</label>
                        <input type="text" class="form-control" id="CurrentActorLegalInfoRequest.Remarks" [(ngModel)]="CurrentActorLegalInfoRequest.Remarks" name="CurrentActorLegalInfoRequest.Remarks" placeholder="Remarks">
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="col-md-12">
                        <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn btn-pink btn-block btn-raised">Submit</button>

                      </div>
                    </div>


                  </div>


                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- // Form actions layout section end -->
  </div>


  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-raised" (click)="activeModal.close('Close click')">Close</button>
  </div>
</div>
<div *ngIf='IsShowDetail'>
  <div class="modal-header">
    <h4 class="modal-title">Legal Detail Info</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <!-- Form actions layout section start -->
    <section id="form-action-layouts">


      <div class="row justify-content-md-center">
        <div class="col-md-12">
          <div class="card">

            <div class="card-body">
              <div class="px-3">
                <detail-grid *ngIf="CurrentActorLegalInfoControllerByCode"
                             [columns]="dcolumns" [data]="CurrentActorLegalInfoControllerByCode">

                </detail-grid>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- // Form actions layout section end -->
  </div>


  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-raised" (click)="activeModal.close('Close click')">Close</button>
  </div>
</div>
